// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2ZUPX","subheader":"ReorderModal_subheader__15PJo","listWrap":"ReorderModal_listWrap__--gL8"};